export default email => `
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close"><span aria-hidden="true" class="close-me">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">Delete user</h4>
      </div>
      <div class="modal-body">
        <h4>Are you sure you want to delete the user with the email: ${email}</h4>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-patient-email="${email}">Delete user</button>
        <button type="button" class="btn btn-default close-me">Cancel</button>
      </div>
    </div>
  </div>
`;
